import React, { useEffect, useRef } from 'react';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import { scrollToBottom } from '../../utils/markdownUtils';

const ChatContent = ({
  messages,
  inputValue,
  onInputChange,
  onSendMessage,
  onKeyPress,
  conversationId,
  isStreaming
}) => {
  const messagesEndRef = useRef(null);

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    scrollToBottom(messagesEndRef);
  }, [messages]);

  const renderWelcomeScreen = () => (
    <div className="d-flex align-items-center justify-content-center h-100">
      <div className="text-center">
        <div className="mb-4">
          <i className="fa fa-robot fa-4x text-theme opacity-25"></i>
        </div>
        <h4 className="text-body mb-3">How can I help you today?</h4>
        <div className="row gx-3">
          <div className="col-lg-6">
            <div className="card mb-3 bg-body bg-opacity-25">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="flex-1">
                    <div className="fw-bold">Explain quantum computing</div>
                    <div className="text-body text-opacity-50 fs-13px">in simple terms</div>
                  </div>
                  <div className="w-40px text-end">
                    <i className="fa fa-arrow-right text-body text-opacity-25"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="card mb-3 bg-body bg-opacity-25">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="flex-1">
                    <div className="fw-bold">Got any creative ideas</div>
                    <div className="text-body text-opacity-50 fs-13px">for a 10 year old's birthday?</div>
                  </div>
                  <div className="w-40px text-end">
                    <i className="fa fa-arrow-right text-body text-opacity-25"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="card mb-3 bg-body bg-opacity-25">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="flex-1">
                    <div className="fw-bold">How do I make an HTTP request</div>
                    <div className="text-body text-opacity-50 fs-13px">in Javascript?</div>
                  </div>
                  <div className="w-40px text-end">
                    <i className="fa fa-arrow-right text-body text-opacity-25"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="card mb-3 bg-body bg-opacity-25">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="flex-1">
                    <div className="fw-bold">Write a thank you note</div>
                    <div className="text-body text-opacity-50 fs-13px">to my interviewer</div>
                  </div>
                  <div className="w-40px text-end">
                    <i className="fa fa-arrow-right text-body text-opacity-25"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="d-flex flex-column h-100">
      {/* Chat Messages Area */}
      <div className="flex-1 overflow-auto px-lg-4 px-3 pt-3">
        <div className="mx-lg-4 mx-2">
          {!conversationId && messages.length === 0 ? (
            renderWelcomeScreen()
          ) : (
            <>
              <ChatMessages messages={messages} />
              <div ref={messagesEndRef} />
            </>
          )}
        </div>
      </div>

      {/* Chat Input Area */}
      <ChatInput
        inputValue={inputValue}
        onInputChange={onInputChange}
        onSendMessage={onSendMessage}
        onKeyPress={onKeyPress}
        disabled={isStreaming}
      />
    </div>
  );
};

export default ChatContent;